import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

let initialState: any = {
  courseLevelResponse: {},
};

// Get CourseLevel API call
export const CourseLevelService = createAsyncThunk(
  "master/courseLevel",
  async (courseLevel: any) => {
    try {
      return await getAPI(CommonEndpoint.courseLevel);
    } catch (err) {
      return err;
    }
  }
);

const courseLevelSlice = createSlice({
  name: "courseLevel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      CourseLevelService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(CourseLevelService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const courseLevelReducer = courseLevelSlice.reducer;
export default courseLevelReducer;
